// extracted by mini-css-extract-plugin
export default {"fullscreen":"App_fullscreen__HoUz3","btn":"App_btn__v3cnz","flex":"App_flex__gNGng","cantStart":"App_cantStart__RpEz5"};